module.exports = __webpack_public_path__ + "static/media/tf.0d67cd70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tf.svg
// module id = 261
// module chunks = 0